import { arrRemove } from '../../../project/src/constant/utils'
import { phoneVali } from './common-methods'

export default {
  methods: {
    async handleBlur(res) {
      let { label, content } = res
      if (label == '手机') {
        if (content && content.length > 0 && this.radish['手机'] != this.formData['手机']) {
          content = content.replace(/[^0-9]/g, '').replace(/^86(.*?)/, '$1')
          if (phoneVali(content)) {
            const isDup = await this.duplicate(content)
            if (isDup) {
              return false
            }
          } else {
            this.$message.info('手机格式错误')
            this.dupData = {}
            return false
          }
        } else {
          this.dupData = {}
          this.isSaveShow = true
        }
      }
      return true
    },
    async loadData() {
      if (this.id) {
        this.ready = false
        this.formData = {
          地域: [],
          职能模块: [],
          细分职能: [],
          擅长方向: [],
          期望行业: [],
          期望地域: [],
          学历标签: [],
          语言标签: [],
          职业资格: [],
          香港牌照: [],
          money: {
            2023: { 月份: 12 },
            2022: { 月份: 12 },
            2021: { 月份: 12 },
            2020: { 月份: 12 },
            2019: { 月份: 12 },
            2018: { 月份: 12 },
            2017: { 月份: 12 },
          },
        }
        this.formExpData = {}
        this.attachType = ''
        this.uploadType = '原始简历'
        this.attachData = []
        this.dupData = {}
        this.isSaveShow = true
        // console.log(this.id)
        const res = await app.service('radish').fetch({ _id: this.id })
        // console.log(res)
        if (res.status == 'success') {
          if (res.data.length == 0) {
            this.$message.error('人选不存在')
            return
          }
          const radish = res.data[0]
          if (radish['建议业绩'] && radish['建议业绩'] instanceof Array) this.recommendYeji = radish['建议业绩']
          if (radish['主管基金'] && radish['主管基金'] instanceof Array) this.mainFunds = radish['主管基金']
          const formExpData = {
            教育: [],
            工作: [],
            项目: [],
          }
          this.radish = radish
          for (const exp of radish.experiences) {
            formExpData[exp.type].push(exp)
          }
          this.formExpData = formExpData
          delete radish.experiences
          this.attachData = radish.attachments
          delete radish.attachments
          for (const k in radish) {
            const val = radish[k]
            if (val) {
              if (k === 'money') {
                for (const year in val) {
                  if (!val[year]['月份']) val[year]['月份'] = 12
                  this.formData.money[year] = val[year]
                }
              } else if (k !== '任职经历' && k !== 'progress') {
                this.formData[k] = val
              }
            }
          }
          this.company = this.formData['公司']
          this.department = this.formData['部门']
          // console.log('f',this.formData)
          // console.log('e',this.formExpData)
          this.ready = true
          this.onReady()
        } else {
          this.$message.error(res.msg)
        }
      }
    },
    handleRemoveTag(res) {
      const { label, tag } = res
      if (label == '职能模块') {
        // if (this.role != '管理员' && !this.prem.includes(tag)) {
        //   this.$message.error('没有删除该职能模块权限');
        //   this.cantRemoveTag = tag;
        // } else {
        const cate = this.catData.filter(cat => cat['名称'] == tag)
        const xi = cate[0]['二级职能'] || []
        const shan = cate[0]['擅长方向'] || []
        if (xi.length > 0) {
          this.formData['细分职能'] = this.formData['细分职能'].filter(x => !xi.includes(x))
        }
        if (shan.length > 0) {
          this.formData['擅长方向'] = this.formData['擅长方向'].filter(s => !shan.includes(s))
        }
        this.formData['专业职级'] = this.formData['职能模块'] && this.formData['职能模块'].includes('HH-猎头') ? ['R', 'AC', 'C', 'SC', 'PC', 'TL\M', 'SM', 'AD', 'D', 'AP', 'P', 'SP', 'Office Head', 'GM', 'CEO'] : ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
        // }
      }
    },
    handleFocus(res) {
      // let {label} = res;
      // if ((label == '职级' || label == '业绩') && this.formData['职能模块'].length>0) {
      //   if (this.role != '管理员' && !this.prem.includes(this.formData['职能模块'][0])) {
      //     this.$message.error('只有有主职能模块权限才能修改职级和业绩');
      //     return false;
      //   }
      // }
      return true
    },
    handleExpChange(res) {
      const { label, content, box, index } = res
      this.formExpData[box][index][label] = content
    },
    handleAttachTypeChange(res) {
      const { label, content } = res
      this.attachType = content
      if (content == '原始简历') {
        this.uploadType = '原始简历'
      } else if (content == '推荐报告') {
        this.uploadType = '推荐报告'
      } else if (content == '会面记录') {
        this.uploadType = '会面记录'
      } else {
        this.uploadType = '附件'
      }
    },
    async duplicate(phone) {
      const dup = await app.service('radish').duplicate({ phone: phone, _id: this.radish._id })
      if (dup.msg == 'duplicate') {
        if (phone != this.radish['手机']) {
          this.dupData = dup.data
          this.isSaveShow = false
          return true
        }
      } else {
        this.dupData = {}
        this.isSaveShow = true
        return false
      }
    },
    async save() {
      // const testData = await this.$refs.testpaper.save()
      // console.log('testData', testData)
      // return
      const vali = await this.fieldValidate(this.formData, this.formExpData)
      if (!vali) {
        return
      }
      if (this.formData['手机']) {
        const ok = await this.handleBlur({
          label: '手机',
          content: this.formData['手机'],
        })
        if (!ok) {
          return false
        }
      }
      this.loading = true
      if (this.$refs.testpaper) {
        const testData = await this.$refs.testpaper.save()
        for (const key in testData) {
          if (key == '微信' && testData[key] == '手机') {
            this.formData[key] = this.formData['手机']
          } else if (testData[key]) {
            this.formData[key] = testData[key]
          }
        }
        delete app.root.$refs.radishDetailTab.unsave[this.radish._id]
      }
      if (this.$refs.bonusSchemes) {
        await this.$refs.bonusSchemes.saveMoney()
      }
      // console.log('save', this.formData, this.formExpData)
      const result = await this.saveForm(this.formData)
      // console.log('basic', result)
      if (result.status == 'success') {
        await this.saveExp(this.formExpData)
        this.$message.success({ duration: 500, message: '保存成功' })
        if (this.type == 'small') {
          window.location.href = `${window.frontend}/#/radish-detail-blank/${this.radish._id}`
          // console.log('small')
          // app.root.$refs.main &&
          //   app.root.$refs.main.$refs.radishList &&
          //   app.root.$refs.main.$refs.radishList.loadOne(this.id)
          // app.root.$refs.main &&
          //   app.root.$refs.main.$refs.radishListPro &&
          //   app.root.$refs.main.$refs.radishListPro.loadOne(this.id)
        }
      } else {
        this.$message.error(result.msg)
      }
      // console.log('show')
      this.loading = false
    },
    fieldValidate(dt, edt) {
      const empty = []
      this.requiredFields.forEach(f => {
        if (f instanceof Object) {
          for (const key in f) {
            const farr = f[key]
            farr.forEach(f2 => {
              if (!edt[key][0][f2]) {
                empty.push(f2)
              }
            })
          }
        } else if (!dt[f]) {
          empty.push(f)
        }
      })
      if (empty.length > 0) {
        this.$alert(`请填写${empty.join('、')}`, { showClose: false })
        return false
      }
      return true
    },
    async saveExp(edt) {
      // console.log(edt)
      const dtAdd = []
      const dtEdit = []
      for (const key in edt) {
        const tmp = edt[key].forEach(item => {
          if (Object.keys(item).length > 0) {
            if (item._id) {
              dtEdit.push(item)
            } else {
              item.rid = this.id
              item.type = key
              dtAdd.push(item)
            }
          }
        })
      }
      if (dtAdd.length > 0) {
        const eRes = await app.service('radish').addExperience(dtAdd)
        // console.log(eRes)
        if (eRes.status == 'fail') {
          this.$message.error(eRes.msg)
        }
      }
      if (dtEdit.length > 0) {
        for (const dt of dtEdit) {
          const eeRes = await app.service('radish').modifyExperience({ query: { _id: dt._id }, data: dt })
          if (eeRes.status == 'fail') {
            this.$message.error(eeRes.msg)
          }
        }
      }
    },
    addExp(k) {
      this.formExpData[k].unshift({})
    },
    delExp(type, index, content) {
      if (content._id) {
        this.$confirm('确定删除该经历吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const deRes = await app.service('radish').deleteExperience({ _id: content._id })
            if (deRes.status == 'success') {
              this.$message.success({ duration: 500, message: deRes.msg })
            } else {
              console.log(deRes.msg)
            }
            this.formExpData[type].splice(index, 1)
          })
          .catch(() => {})
      } else {
        this.formExpData[type].splice(index, 1)
      }
    },
    showUpload() {
      this.typeVisible = true
    },
    showUploadDia() {
      if (!this.attachType) return this.$message('请选择附件类型')
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
      this.typeVisible = false
    },
    showTxtUpload() {
      this.attachType = '原始简历'
      this.$refs.TextUploadDialog && this.$refs.TextUploadDialog.visible()
    },
    uploadCv() {
      this.attachType = '原始简历'
      this.uploadType = '原始简历'
      this.showUploadDia()
    },
    uploadReport() {
      this.attachType = '推荐报告'
      this.uploadType = '推荐报告'
      this.showUploadDia()
    },
    uploadHuimian() {
      this.attachType = '会面记录'
      this.uploadType = '会面记录'
      this.showUploadDia()
    },
    showParse() {
      this.currentParseMd5 = ''
      this.parseVisible = true
    },
    parseCv: async function() {
      if (this.currentParseMd5) {
        this.parseVisible = false
        this.$refs.parsePreview.open(this.currentParseMd5, this.id, this.radish)
      }
    },
    uploadSuccess: async function(response, file, fileList) {
      for (const res of response) {
        const dt = {
          fileId: res._id,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          md5: res.md5,
          type: this.attachType,
          rid: this.id,
        }
        if (this.attachType === '推荐报告') {
          dt.isFinal = true
        }
        const aRes = await app.service('radish').addAttachment(dt)
        if (aRes.status == 'success') {
          dt.createdAt = Date.now()
          dt._id = aRes.data.ids[0]
          this.attachData.push(dt)
        }
        this.$refs.UploadDialog.visible()
        if (this.attachType == '原始简历') {
          this.currentParseMd5 = res.md5
          this.parseCv()
        }
      }
    },
    uploadTxtSuccess: async function(res) {
      const file = res[0]
      const dt = {
        fileId: file._id,
        uploader: file.uploader,
        originalname: file.originalname,
        src: file.src,
        md5: file.md5,
        type: this.attachType,
        rid: this.id,
      }
      const aRes = await app.service('radish').addAttachment(dt)
      if (aRes.status == 'success') {
        dt.createdAt = Date.now()
        this.attachData.push(dt)
      }
    },
    showIntoProject() {
      const rows = [this.radish]
      app.root.$refs.radishProDialog.show(rows, 'intoProject')
    },
    showRecommend() {
      const rows = [this.radish]
      app.root.$refs.radishProDialog.show(rows, 'recommend')
    },
    showIntoFav() {
      app.root.$refs.favDialog.show([this.radish])
    },
    genRepo() {
      app.root.$refs.reportMaker.init({ radish: this.radish._id })
    },
    showOchart() {
      if (this.formData['公司'] && this.formData['部门']) {
        app.root.$refs.departmentOchart.open({
          department: this.formData['部门'],
          companyName: this.formData['公司'],
          rid: this.formData._id,
        })
        // console.log(this.formData)
      } else {
        this.$refs.ComDepartDialog.show(this.formData['公司'], this.formData['部门'])
      }
    },
    async handleComDepart(company, department) {
      const dt = { 部门: department }
      if (company != this.radish['公司']) {
        dt['公司'] = company
      }
      await app.service('radish').modifyById({ _id: this.radish._id, data: dt })
      this.loadData()
      app.root.$refs.departmentOchart.open({ department: department, companyName: company, rid: this.radish._id })
    },
    showScore() {
      app.root.$refs.radishScore.open(this.radish._id)
    },
    loadBulletins: async function() {
      if (this.bulletins.length == 0) {
        if (this.radish['公司']) {
          const res = await app.service('radish').leaveForecast(this.radish)
          if (res.status == 'success' && res.data.length > 0) {
            this.bulletins = res.data
          } else {
            this.$message.info('无相应公告')
          }
          this.showBull = !this.showBull
          this.showGou = false
        } else {
          this.$message.info('人选无公司')
        }
      } else {
        this.showBull = !this.showBull
        this.showGou = false
      }
    },
    toggleGou() {
      this.showGou = !this.showGou
      this.showBull = false
    },
    showRadish(params) {
      const { id, name } = params
      app.root.$refs.radishLeft.show(id)
    },
    showDiff() {
      const newData = JSON.parse(JSON.stringify(this.formData))
      this.$refs.DetailDiff.show({ oldId: this.dupData.id, newData, onConfirm: this.onClose })
    },
    async delOld() {
      if (this.sending) return false
      this.sending = true
      const newData = JSON.parse(JSON.stringify(this.formData))
      const res = await app.service('radish').mergeTwo({ oldId: this.dupData.id, newData })
      if (res.status == 'success') {
        this.$message.success({ duration: 500, message: '成功' })
        this.onClose()
        app.root.$refs.radishDetailTab.addTab({ id: newData._id })
      } else {
        this.$message.error(res.msg)
      }
      this.sending = false
    },
    async giveUp() {
      if (this.sending) return false
      this.sending = true
      const res = await app.service('radish').mergeTwo({ oldId: this.formData._id, newData: { _id: this.dupData.id } })
      if (res.status == 'success') {
        this.$message.success({ duration: 500, message: '成功' })
        this.onClose()
        app.root.$refs.radishDetailTab.addTab({ id: this.dupData.id })
      } else {
        this.$message.error(res.msg)
      }
      this.sending = false
    },
    onModifyField(dt) {
      this.ready = false
      for (const k in dt) {
        const v = dt[k]
        this.radish[k] = v
        this.formData[k] = v
        if (k === '公司') this.company = v
        if (k === '部门') this.department = v
      }
      app.root.$refs.main &&
        app.root.$refs.main.$refs.radishList &&
        app.root.$refs.main.$refs.radishList.loadOne(this.id)
      this.ready = true
    },
    onAddOneExp(type, exp) {
      this.formExpData[type].unshift(exp)
      app.root.$refs.main &&
        app.root.$refs.main.$refs.radishList &&
        app.root.$refs.main.$refs.radishList.loadOne(this.id)
    },
    onModifyAll() {
      this.loadData()
      app.root.$refs.main &&
        app.root.$refs.main.$refs.radishList &&
        app.root.$refs.main.$refs.radishList.loadOne(this.id)
    },
    formatTime(time) {
      return dateFormat(new Date(time), 'yyyy-mm-dd HH:MM:ss')
    },
    unique(arr) {
      return Array.from(new Set(arr))
    },
    moneyInput(year) {
      const money = JSON.parse(JSON.stringify(this.formData.money[year]))
      if (money['月固']) {
        money['固薪'] = (parseFloat(money['月固'] || 0) * parseInt(money['月份'] || 12)).toFixed(1)
      }
      if (money['月固'] && money['奖金月数']) {
        money['奖金'] = (parseFloat(money['月固']) * parseInt(money['奖金月数'])).toFixed(1)
      }
      this.formData.money[year] = money
      if (money['固薪'] || money['奖金']) {
        money['全薪'] = (parseFloat(money['固薪'] || 0) + parseFloat(money['奖金'] || 0)).toFixed(1)
      }
    },
    phoneToWx() {
      this.ready = false
      this.formData['微信'] = this.formData['手机']
      this.ready = true
    },
    async deleteAttachment({ _id }) {
      try {
        const { status, msg } = await app.service('radish').deleteAttachment({ _id })
        if (status === 'success') {
          arrRemove(this.attachData, file => file._id === _id)
          this.$message({ message: msg, type: 'success' })
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async markAttachment(attach) {
      try {
        const { status, msg, data } = await app.service('radish').markWrongAttach({ rid: attach.rid, md5: attach.md5 })
        if (status === 'success') {
          this.attachData = this.attachData.map(atta => {
            if (atta._id === attach._id) {
              atta.isWrong = data.isWrong
            }
            return atta
          })
          this.$message({ message: msg, type: 'success' })
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async searchCompany(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      let results = []
      const res = await app.service('company').completeCompanyName(queryString)
      if (res.status === 'success') {
        results = res.data.map(c => ({ value: c.简称 }))
      }
      cb(results)
    },
    async searchDepartment(queryString, cb) {
      if (!queryString || !this.company) {
        cb([])
        return
      }
      let results = []
      const res = await app.service('company').completeDepartmentName({ 公司: this.company, 部门: queryString })
      if (res.status === 'success') {
        results = res.data.map(d => ({ value: d }))
      }
      cb(results)
    },
  },
  watch: {
    id: function() {
      this.loadData()
    },
    company: function(newVal) {
      if (this.formData['公司'] != newVal) this.formData['公司'] = newVal
    },
    department: function(newVal) {
      if (this.formData['部门'] != newVal) this.formData['部门'] = newVal
    },
  },
}
